import '@webcomponents/template';
import 'core-js/fn/symbol/iterator.js';// NOTE: Dependency of @babel/polyfill: needed for IE11
import 'core-js/es6/symbol';// NOTE: Dependency of @babel/polyfill: needed for IE11

import template from './templates/template-container';

import { render } from 'lit-html';

import Project from './project';

const { __ } = wp.i18n;

export default function ProjectOffer(container, endpoints, options) {
	this.container = container && container.nodeType === 1 ? container : null;

	if (this.container.nodeType !== 1) {
		throw new Error('No container for ProjectSituationMap defined');
	}

	if (!this.container.hasAttribute('data-module-id')) {
		throw new Error('No data-module-id attribute found on the container element');
	}

	this.state = {
		projectDataLoaded: false,
		realEstateObjectDataLoaded: false,
		projectsDisplayed: [],
		filterValues: [],
		showAvailablePropertiesCount: false,
		errorMessages: []
	};

	this.projects = [];
	this.filters = [];

	this._projectData = [];
	this._reqRealEstateObjects = [];

	this.endpoints = {
		projects: ''
	};

	for (let attrname in endpoints) { this.endpoints[attrname] = endpoints[attrname]; }

	//default options
	this.props = {
		title: this.container.getAttribute('data-title'),
		filterBackgroundImageSrc: this.container.getAttribute('data-filter-background-image-src'),
		filtersToDisplay: this.container.hasAttribute('data-filters-to-display') ? this.container.getAttribute('data-filters-to-display').split(',') : [],
		priceFilterSteps: [0, 50000, 75000, 100000, 125000, 150000, 175000, 200000, 225000, 250000, 275000, 300000, 350000, 400000, 450000, 500000, 550000, 600000, 700000, 800000, 900000, 1000000, 1100000, 1250000, 1500000],
		propertyTypeFromHouseTypes: this.container.hasAttribute('data-property-type-from-house-types')// TODO: remove when Nieuwbouw Nederland supports alle property types on objects
	};

	//voeg input opties samen met default opties
	for (let attrname in options) { this.props[attrname] = props[attrname]; }

	const reqProjects = new XMLHttpRequest();

	reqProjects.addEventListener('readystatechange', () => {
		if (reqProjects.readyState !== 4) return;
		if (reqProjects.status !== 200 && reqProjects.status !== 304) {
			console.log('HTTP error ' + reqProjects.status);
			return;
		}

		this._projectData = JSON.parse(reqProjects.responseText);
		if (this._projectData.error) {
			this.setState('errorMessages', this.state.errorMessages.concat([this._projectData.error]));
			this.setState('projectDataLoaded', true);
			return;
		}

		this.projects = this._projectData.map(projectData => new Project(projectData));

		this.setState('projectDataLoaded', true);
		this.setupFilters();
		this.updateDisplayedProjects();
	});

	reqProjects.open('GET', this.endpoints.projects);
	reqProjects.setRequestHeader('Content-Type', 'application/json');
	reqProjects.send();

	if (this.container.hasAttribute('data-show-available-properties-count')) {
		this.setState('showAvailablePropertiesCount', true);
	}

	this.render();
}

ProjectOffer.prototype.render = function() {
	render(template(this), this.container);
};

ProjectOffer.prototype.setState = function(prop, value) {
	if (typeof this.state[prop] !== 'undefined') {
		this.state[prop] = value;
	}
	this.render();
};

ProjectOffer.prototype.isProjectsLoaded = function() {
	return this.state.projectDataLoaded;
};

ProjectOffer.prototype.updateDisplayedProjects = function() {
	if (this.filters.length <= 0) {
		this.setState('projectsDisplayed', this.projects);
	}

	this.setState('projectsDisplayed', this.projects.filter(project => {
		const matchedFilters = this.filters.filter(filter => filter.isMatch(project, this.getFilterValue(filter.name))).filter(match => match);
		return matchedFilters.length === this.filters.length;
	}));
};

ProjectOffer.prototype.getFilterValue = function(name) {
	const filtersWithName = this.state.filterValues.filter(filter => filter.name === name);
	return filtersWithName.length === 1 ? filtersWithName[0].value : '';
};

ProjectOffer.prototype.updateFilterValue = function(name, value) {
	this.setState('filterValues', this.state.filterValues.map(filter => ({
		name: filter.name,
		value: name === filter.name ? value : filter.value
	})));
	this.updateDisplayedProjects();
};

ProjectOffer.prototype.setupFilters = function() {
	let filters = [
		{
			label: __( 'Status', 'real-estate-project' ),
			name: 'status',
			type: 'select',
			handleEvent: (e => this.updateFilterValue(e.target.name, e.target.value)),
			options: this.projects.map(project => ({
				text: project.getStatusLabel(),
				value: project.getStatus()
			})).filter((option, index, options) => {
				const foundIndex = options.findIndex(status => option.value === status.value);
				return foundIndex === index;
			}),
			defaultValue: '',
			isMatch: (project, currentFilterValue) => project.getStatus() === currentFilterValue || !currentFilterValue,
			getValue: () => this.getFilterValue('status')
		},
		{
			label: __( 'Type', 'real-estate-project' ),
			name: 'property-type',
			type: 'select',
			handleEvent: (e => this.updateFilterValue(e.target.name, e.target.value)),
			options: (() => {
				let propertyTypes = [];
				this.projects.forEach(project => {
					propertyTypes = propertyTypes.concat(project.getPropertyTypes(this.props.propertyTypeFromHouseTypes).map(propertyType => ({ // TODO: remove "this.props.propertyTypeFromHouseTypes" when Nieuwbouw Nederland supports alle property types on objects
						text: propertyType.label,
						value: propertyType.value
					})));
				});
				return propertyTypes.filter((option, index, options) => {
					const foundIndex = options.findIndex(propertyType => option.value === propertyType.value);
					return foundIndex === index;
				}).sort((a, b) => {
					if (a.text < b.text) {
						return -1;
					}
					if (a.text > b.text) {
						return 1;
					}
					return 0;
				});
			})(),
			defaultValue: '',
			isMatch: (project, currentFilterValue) => !currentFilterValue || project.getPropertyTypes(this.props.propertyTypeFromHouseTypes).findIndex(propertyType => propertyType.value === currentFilterValue) >= 0,// TODO: remove "this.props.propertyTypeFromHouseTypes" when Nieuwbouw Nederland supports alle property types on objects
			getValue: () => this.getFilterValue('property-type')
		},
		{
			label: __( 'Price from', 'real-estate-project' ),
			name: 'price-from',
			type: 'select',
			handleEvent: (e => this.updateFilterValue(e.target.name, e.target.value)),
			options: this.getPriceFromOptions(),
			defaultValue: '',
			isMatch: (project, currentFilterValue) => {
				const object = project.getHighestPriceObject();
				return !currentFilterValue || object && object.price > currentFilterValue;
			},
			getValue: () => this.getFilterValue('price-from')
		},
		{
			label: __( 'Price up to', 'real-estate-project' ),
			name: 'price-up-to',
			type: 'select',
			handleEvent: (e => this.updateFilterValue(e.target.name, e.target.value)),
			options: this.getPriceUpToOptions(),
			defaultValue: '',
			isMatch: (project, currentFilterValue) => {
				const object = project.getLowestPriceObject();
				return !currentFilterValue || object && object.price < currentFilterValue;
			},
			getValue: () => this.getFilterValue('price-up-to')
		},
		{
			label: __( 'Rent or purchase', 'real-estate-project' ),
			name: 'rent-or-purchase',
			type: 'select',
			handleEvent: (e => this.updateFilterValue(e.target.name, e.target.value)),
			options: this.projects.map(project => ({
				text: project.getRentBuyStatusLabel(),
				value: project.getRentBuyStatus()
			})).filter((option, index, options) => {
				const foundIndex = options.findIndex(type => option.value === type.value);
				return foundIndex === index;
			}),
			defaultValue: '',
			isMatch: (project, currentFilterValue) => project.getRentBuyStatus() === currentFilterValue || !currentFilterValue,
			getValue: () => this.getFilterValue('rent-or-purchase')
		}
	];

	this.filters = this.props.filtersToDisplay ? filters.filter(filter => this.props.filtersToDisplay.indexOf(filter.name) >= 0) : filters;

	this.setState('filterValues', this.filters.map(filter => ({
		name: filter.name,
		value: filter.defaultValue
	})));
};

ProjectOffer.prototype.getPriceFromOptions = function() {
	return this.props.priceFilterSteps.filter((priceStep, index, priceSteps) => {
		const lowestPriceObject = this.getLowestPriceObject(this.projects);
		const highestPriceObject = this.getHighestPriceObject(this.projects);
		return priceStep >= lowestPriceObject.price && (priceSteps[index-1] && priceSteps[index-1] <= highestPriceObject.price);
	}).map(priceStep => ({
		text: '€ ' + priceStep.toLocaleString(rep_default_locale) + ',-',
		value: priceStep
	}));
};

ProjectOffer.prototype.getPriceUpToOptions = function() {
	return this.props.priceFilterSteps.filter((priceStep, index, priceSteps) => {
		const lowestPriceObject = this.getLowestPriceObject(this.projects);
		const highestPriceObject = this.getHighestPriceObject(this.projects);
		return priceStep >= lowestPriceObject.price && (priceSteps[index-1] && priceSteps[index-1] <= highestPriceObject.price);
	}).map(priceStep => ({
		text: '€ ' + priceStep.toLocaleString(rep_default_locale) + ',-',
		value: priceStep
	}));
};

ProjectOffer.prototype.getLowestPriceObject = function(projects) {
	const lowestPricedObjects = projects.map(project => project.getLowestPriceObject()).filter(realEstateObject => realEstateObject);

	lowestPricedObjects.sort((a, b) => {
		if (a.price < b.price) {
			return -1;
		}
		if (a.price > b.price) {
			return 1;
		}
		return 0;
	});

	return lowestPricedObjects.length > 0 ? lowestPricedObjects[0] : null;
};

ProjectOffer.prototype.getHighestPriceObject = function(projects) {
	const highestPricedObjects = projects.map(project => project.getHighestPriceObject()).filter(realEstateObject => realEstateObject);

	highestPricedObjects.sort((a, b) => {
		if (a.price > b.price) {
			return -1;
		}
		if (a.price < b.price) {
			return 1;
		}
		return 0;
	});

	return highestPricedObjects.length > 0 ? highestPricedObjects[0] : null;
};